<app-header></app-header>
<main>
  <app-hero></app-hero>
  <app-testimonials></app-testimonials>
  <app-services></app-services>
  <app-how-it-works></app-how-it-works>
  <app-portfolio></app-portfolio>
  <app-integrations></app-integrations>
  <app-pricing></app-pricing>
  <app-cta-banner></app-cta-banner>
  <app-about></app-about>
  <app-faq></app-faq>
  <app-contact></app-contact>
</main>
<app-footer></app-footer>

<!-- Scroll Navigation -->
<div class="scroll-navigation">
  <button *ngIf="showScrollTop" class="scroll-btn scroll-up" (click)="scrollToTop()" aria-label="Scroll to top">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="18 15 12 9 6 15"></polyline>
    </svg>
  </button>
  <button *ngIf="showScrollBottom" class="scroll-btn scroll-down" (click)="scrollToBottom()" aria-label="Scroll to bottom">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="6 9 12 15 18 9"></polyline>
    </svg>
  </button>
</div>
